module.exports = __webpack_public_path__ + "static/media/homeIcon.b9066bfd.svg";